import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppConfigProvider } from './context/app-configs-context';
import { AuthProvider } from './context/auth-context';
import App from './App';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <AuthProvider>
            <AppConfigProvider>
                <App/>
            </AppConfigProvider>
        </AuthProvider>
    </React.StrictMode>,
);
